module.exports = {"150421100":"天山镇","150421101":"天山口镇","150421102":"双胜镇","150421103":"坤都镇","150421104":"巴彦花镇","150421105":"绍根镇","150421106":"扎嘎斯台镇","150421200":"新民乡","150421201":"先锋乡","150421202":"罕苏木苏木","150421203":"赛罕塔拉苏木","150421204":"巴拉奇如德苏木","150421205":"乌兰哈达乡","150421206":"巴彦温都尔苏木","150421400":"轻工食品产业园","150421401":"新能源产业园","150421402":"绍根煤碳及煤化工产业园","150421403":"罕乌拉街道","150421404":"欧沐沦街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150421.json
// module id = 506
// module chunks = 0